import React from 'react';
import { ArrowRight } from 'lucide-react';

const CATEGORY_ICONS = {
    'cat-fruits': '🍎',
    'cat-legumes': '🥬',
    'cat-bio': '🌱',
    'cat-plantes': '🌿',
    'cat-african': '🌍',
    'cat-cosmetics': '✨',
};

const CATEGORY_COLORS = {
    'cat-fruits': '#EF4444',
    'cat-legumes': '#16A34A',
    'cat-bio': '#4CAF50',
    'cat-plantes': '#10B981',
    'cat-african': '#D97706',
    'cat-cosmetics': '#A855F7',
};

export { CATEGORY_ICONS, CATEGORY_COLORS };

export const FamilyCard = ({ category, onClick }) => {
    const color = CATEGORY_COLORS[category.id] || '#22C55E';
    const icon = CATEGORY_ICONS[category.id] || '📦';

    return (
        <button
            onClick={onClick}
            className="group relative overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-left"
            data-testid={`family-card-${category.id}`}
        >
            <div className="relative h-44 sm:h-52 overflow-hidden">
                {category.image_url ? (
                    <img
                        src={category.image_url}
                        alt={category.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                ) : (
                    <div
                        className="w-full h-full flex items-center justify-center text-6xl"
                        style={{ backgroundColor: color + '15' }}
                    >
                        {icon}
                    </div>
                )}
                <div
                    className="absolute inset-0"
                    style={{
                        background: `linear-gradient(to top, ${color}CC 0%, ${color}33 40%, transparent 70%)`,
                    }}
                />
                <div
                    className="absolute top-3 right-3 w-10 h-10 rounded-xl flex items-center justify-center text-xl backdrop-blur-sm"
                    style={{ backgroundColor: 'rgba(255,255,255,0.85)' }}
                >
                    {icon}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-lg sm:text-xl font-bold text-white drop-shadow-md">
                    {category.name}
                </h3>
                <p className="text-white/80 text-xs sm:text-sm mt-0.5 line-clamp-1 drop-shadow">
                    {category.description}
                </p>
                <div className="flex items-center gap-1 mt-2 text-white/90 text-xs font-medium group-hover:gap-2 transition-all">
                    Voir les produits
                    <ArrowRight className="w-3.5 h-3.5" />
                </div>
            </div>
        </button>
    );
};
